module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-bouquet-2-1a6d07fc283d896e7d6530599a27e572.jpg";